import './polyfills.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import { AuthProvider } from './context/AuthContext';
import { initMonitoring } from './lib/monitoring';
import { preloadFeatured } from './lib/preload';

initMonitoring();
preloadFeatured();

const recoveryPath = sessionStorage.getItem('diwanRecoveryPath');
if (recoveryPath) {
  sessionStorage.removeItem('diwanRecoveryPath');
  // Use replaceState so the recovery path becomes the current route
  // without adding a spurious history entry
  window.history.replaceState(null, '', recoveryPath);
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Never reload during auth flows — a mid-exchange reload invalidates the
    // single-use PKCE code, leaving the browser stuck on "Signing in…".
    const { pathname, search, hash } = window.location;
    const inAuthFlow =
      pathname.startsWith('/auth/') ||
      pathname.startsWith('/reset-password') ||
      search.includes('code=') ||
      hash.includes('access_token');
    if (!inAuthFlow) {
      window.location.reload();
    }
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
